module.exports = __webpack_public_path__ + "static/media/sms.dd66a862.svg";